/*#__PURE__*/ export default JSON.parse('{"key":"competitionsTable","type":"root","items":[{"key":"showTeamIcons","def":true,"type":"bool"}]}');